import { render, staticRenderFns } from "./parkDetails.vue?vue&type=template&id=22e05984&scoped=true"
import script from "./parkDetails.vue?vue&type=script&lang=js"
export * from "./parkDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e05984",
  null
  
)

export default component.exports